import Icon from 'veui/components/Icon'
import { IconUpload } from 'dls-icons-vue'

Icon.register('upload', IconUpload)
